import { IXSLXImport } from '@principle-theorem/shared';
import {
  APPOINTMENT_BOOK_TO_STATUS_HEADERS,
  IAppointmentBookToStatusXLSX,
} from './appointment-book-to-status-to-xlsx';
import { Row } from 'exceljs';

export class XSLXToAppointmentBookToStatus
  implements IXSLXImport<IAppointmentBookToStatusXLSX>
{
  headers = APPOINTMENT_BOOK_TO_STATUS_HEADERS;

  translate(row: Row): IAppointmentBookToStatusXLSX {
    return {
      sourceId: row.getCell('sourceId').value?.toString() ?? '',
      sourceName: row.getCell('sourceName').value?.toString() ?? '',
      mapTo: row
        .getCell('mapTo')
        .value?.toString() as IAppointmentBookToStatusXLSX['mapTo'],
    };
  }
}
